import { FC, useState } from 'react';

import { PublicUserConnectionComparison } from '@shared/types/userConnection';

import Button from '@components/buttons/Button';
import { MultipleChoiceList } from '@components/form/MultipleChoiceList';
import { Popup } from '@components/layout/Popup/Popup';
import { TitleToolbar } from '@components/layout/TitleToolbar/TitleToolbar';

const CONNECT_OPTIONS = [
  { label: 'Duh of course?', payloadValue: 'yes' },
  { label: 'Sure, why not?', payloadValue: 'yes' },
  { label: "No, we're not that close", payloadValue: 'no' },
].map(({ label, payloadValue }) => ({ label, value: label, payloadValue }));

interface EventConnectPopupContentProps {
  connectionComparison: PublicUserConnectionComparison;
  onClose: () => void;
  onSubmit?: (selectedValue: string) => void;
}

interface EventConnectPopupProps extends EventConnectPopupContentProps {
  isVisible: boolean;
}

const PopupContent: FC<EventConnectPopupContentProps> = ({
  connectionComparison,
  onSubmit,
  onClose,
}) => {
  const [selectedValue, setSelectedValue] = useState<string | undefined>();

  const handleSubmit = () => {
    if (!selectedValue) return;
    onSubmit?.(selectedValue);
    onClose();
  };

  return (
    <div>
      <TitleToolbar text={`Add ${connectionComparison.connectionName} as a friend?`} size="md" />
      <p className="mt-0">
        Do you want to stay updated on the events {connectionComparison.connectionName} is going to?
        Add them as a friend see.
      </p>
      <MultipleChoiceList
        options={CONNECT_OPTIONS}
        onChange={([value]) => setSelectedValue(value)}
      />
      <Button className="mt-2" roundness="rounded" disabled={!selectedValue} onClick={handleSubmit}>
        Submit
      </Button>
    </div>
  );
};

export const EventConnectPopup: FC<EventConnectPopupProps> = ({ isVisible, ...props }) => {
  return (
    <Popup isVisible={isVisible} onClose={props.onClose}>
      <Popup.Content>{isVisible && <PopupContent {...props} />}</Popup.Content>
    </Popup>
  );
};
